import {useRef} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {WideContent} from "@pg-design/grid-module";
import {calculateRemSize, mb, onDesktop, pb, w100} from "@pg-design/helpers-css";
import {navigationHeight} from "@pg-design/navigation";
import {useIsMounted} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";

import {PinState} from "../../navigation/types/pin_state";
import {SlotOrderType} from "../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../search/constants/search_form_with_drawer_height";
import {tdaDesktopHeight} from "../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../store/hooks";

const getListFriendlyLink = ({friendlySlug, offerListSubFilterSlug}: {friendlySlug: string; offerListSubFilterSlug?: string}) => {
    return offerListSubFilterSlug
        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
        : rpAppLink.offer.listFriendly({friendlySlug});
};

const getAbroadListFriendlyLink = ({friendlySlug, country, abroadRegionSlug}: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => {
    return rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug});
};

export const OfferListViewNavigation = () => {
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const list = useAppSelector((state) => state.offerList.list);
    const isListingNavigationSticky = useAppSelector((state) => state.offerListing.isListingNavigationSticky);
    const navigationRef = useRef<HTMLDivElement>(null);
    const isMounted = useIsMounted();

    /**
     * TODO: Navigation height changes between screen sizes, we should put the height in
     *  redux instead of relying on fixed values, not adding it currently, afraid of shock on business side
     */
    // useEffect(() => {
    //     const navigationResizeObserver = new ResizeObserver((entries) => {
    //         for (const entry of entries) {
    //             const navigation = entry.contentRect;
    //             const height = navigation.height;
    //         }
    //     });
    //
    //     if (navigationRef.current) {
    //         navigationResizeObserver.observe(navigationRef.current);
    //     }
    //
    //     return () => {
    //         navigationResizeObserver.disconnect();
    //     };
    // }, []);

    return (
        <Wrapper navigationState={navigationState} isListingNavigationSticky={!isListingNavigationSticky} isMounted={isMounted} ref={navigationRef}>
            <WideContentStyled navigationState={navigationState} isListingNavigationSticky={!isListingNavigationSticky}>
                <SearchFormWithDrawer
                    multiRegionLink={rpAppLink.offer.multiList}
                    latestQuery={list.latestQuery}
                    listFriendlyLink={getListFriendlyLink}
                    abroadListFriendlyLink={getAbroadListFriendlyLink}
                    sortActive
                    shouldRenderListBackBtn
                    slotOrder={SlotOrderType.ROW_REVERSE}
                    showTopFilters
                    blendTop={`${tdaDesktopHeight + searchFormWithDrawerHeight}px`}
                    blendHeightDecrease={`${tdaDesktopHeight + searchFormWithDrawerHeight + navigationHeight}px`}
                />
            </WideContentStyled>
        </Wrapper>
    );
};

export const Wrapper = styled.div<{isListingNavigationSticky: boolean; navigationState: PinState; isMounted: boolean}>`
    top: 0;
    z-index: 6;
    transition: top 200ms ease-in-out;
    padding-bottom: 0;
    ${({isMounted, navigationState}) =>
        isMounted &&
        navigationState !== "unfixed" &&
        css`
            position: sticky;
        `};

    ${({navigationState}) => {
        switch (navigationState) {
            case "pinned": {
                return css`
                    top: ${navigationHeight}px;
                `;
            }
            case "unpinned": {
                return css`
                    top: calc(${-navigationHeight}px + ${calculateRemSize(1)});
                `;
            }
            default:
            case "unfixed": {
                return css`
                    top: 0;
                `;
            }
        }
    }}

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        top: initial;
        z-index: initial;
        height: initial;
        padding-bottom: initial;
        margin-bottom: initial;
        position: initial;
    }
`;

export const WideContentStyled = styled(WideContent)<{isListingNavigationSticky: boolean; navigationState: PinState; isInvestment?: boolean}>`
    ${mb(1.5)};
    ${pb(1.5)};
    ${onDesktop(mb(3))};
    transition: top 200ms ease-in-out;
    ${elevation(4)};
    background-color: #fff;
    position: relative;
    ${w100};

    @media (min-width: 0px) {
        margin-left: initial;
        margin-right: initial;
        max-width: initial;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        background-color: initial;
        ${elevation(0)};
        max-width: var(--grid-md-widthPx);
        margin-left: auto;
        margin-right: auto;
        position: initial;

        ${({isInvestment}) =>
            isInvestment &&
            `
         margin-bottom:0;
         padding-bottom:0;
          `}
    }

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        max-width: var(--grid-lg-widthPx);
    }
`;
import {useRef} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {WideContent} from "@pg-design/grid-module";
import {calculateRemSize, mb, onDesktop, pb, w100} from "@pg-design/helpers-css";
import {navigationHeight} from "@pg-design/navigation";
import {useIsMounted} from "@pg-mono/hooks";
import {rpAppLink} from "@pg-mono/rp-routes";

import {PinState} from "../../navigation/types/pin_state";
import {SlotOrderType} from "../../search/components/search_autocomplete/SearchAutocompleteInputWithSlot";
import {SearchFormWithDrawer} from "../../search/components/SearchFormWithDrawer";
import {searchFormWithDrawerHeight} from "../../search/constants/search_form_with_drawer_height";
import {tdaDesktopHeight} from "../../smart_ad_server/constants/tda_desktop_height";
import {useAppSelector} from "../../store/hooks";

const getListFriendlyLink = ({friendlySlug, offerListSubFilterSlug}: {friendlySlug: string; offerListSubFilterSlug?: string}) => {
    return offerListSubFilterSlug
        ? rpAppLink.offer.listFriendlySubFilterGeneral({friendlySlug, offerListSubFilter: offerListSubFilterSlug})
        : rpAppLink.offer.listFriendly({friendlySlug});
};

const getAbroadListFriendlyLink = ({friendlySlug, country, abroadRegionSlug}: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => {
    return rpAppLink.offer.listFriendlyAbroad({friendlySlug, country, abroadRegionSlug});
};

export const OfferListViewNavigation = () => {
    const navigationState = useAppSelector((state) => state.navigation.pinState);
    const list = useAppSelector((state) => state.offerList.list);
    const isListingNavigationSticky = useAppSelector((state) => state.offerListing.isListingNavigationSticky);
    const navigationRef = useRef<HTMLDivElement>(null);
    const isMounted = useIsMounted();

    /**
     * TODO: Navigation height changes between screen sizes, we should put the height in
     *  redux instead of relying on fixed values, not adding it currently, afraid of shock on business side
     */
    // useEffect(() => {
    //     const navigationResizeObserver = new ResizeObserver((entries) => {
    //         for (const entry of entries) {
    //             const navigation = entry.contentRect;
    //             const height = navigation.height;
    //         }
    //     });
    //
    //     if (navigationRef.current) {
    //         navigationResizeObserver.observe(navigationRef.current);
    //     }
    //
    //     return () => {
    //         navigationResizeObserver.disconnect();
    //     };
    // }, []);

    return (
        <Wrapper navigationState={navigationState} isListingNavigationSticky={!isListingNavigationSticky} isMounted={isMounted} ref={navigationRef}>
            <WideContentStyled navigationState={navigationState} isListingNavigationSticky={!isListingNavigationSticky}>
                <SearchFormWithDrawer
                    multiRegionLink={rpAppLink.offer.multiList}
                    latestQuery={list.latestQuery}
                    listFriendlyLink={getListFriendlyLink}
                    abroadListFriendlyLink={getAbroadListFriendlyLink}
                    sortActive
                    shouldRenderListBackBtn
                    slotOrder={SlotOrderType.ROW_REVERSE}
                    showTopFilters
                    blendTop={`${tdaDesktopHeight + searchFormWithDrawerHeight}px`}
                    blendHeightDecrease={`${tdaDesktopHeight + searchFormWithDrawerHeight + navigationHeight}px`}
                />
            </WideContentStyled>
        </Wrapper>
    );
};

export const Wrapper = styled.div<{isListingNavigationSticky: boolean; navigationState: PinState; isMounted: boolean}>`
    top: 0;
    z-index: 6;
    transition: top 200ms ease-in-out;
    padding-bottom: 0;
    ${({isMounted, navigationState}) =>
        isMounted &&
        navigationState !== "unfixed" &&
        css`
            position: sticky;
        `};

    ${({navigationState}) => {
        switch (navigationState) {
            case "pinned": {
                return css`
                    top: ${navigationHeight}px;
                `;
            }
            case "unpinned": {
                return css`
                    top: calc(${-navigationHeight}px + ${calculateRemSize(1)});
                `;
            }
            default:
            case "unfixed": {
                return css`
                    top: 0;
                `;
            }
        }
    }}

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        top: initial;
        z-index: initial;
        height: initial;
        padding-bottom: initial;
        margin-bottom: initial;
        position: initial;
    }
`;

export const WideContentStyled = styled(WideContent)<{isListingNavigationSticky: boolean; navigationState: PinState; isInvestment?: boolean}>`
    ${mb(1.5)};
    ${pb(1.5)};
    ${onDesktop(mb(3))};
    transition: top 200ms ease-in-out;
    ${elevation(4)};
    background-color: #fff;
    position: relative;
    ${w100};

    @media (min-width: 0px) {
        margin-left: initial;
        margin-right: initial;
        max-width: initial;
    }

    @media (min-width: ${(props) => props.theme.breakpoints.md}) {
        background-color: initial;
        ${elevation(0)};
        max-width: var(--grid-md-widthPx);
        margin-left: auto;
        margin-right: auto;
        position: initial;

        ${({isInvestment}) =>
            isInvestment &&
            `
         margin-bottom:0;
         padding-bottom:0;
          `}
    }

    @media (min-width: ${(props) => props.theme.breakpoints.lg}) {
        max-width: var(--grid-lg-widthPx);
    }
`;
